// Utils
import { findObjectWithIdInObject } from './findObjectWithIdInObject';
/**
 * Find the object with the given object id in the given object
 *
 * @template T extends object
 * @param {T} values
 * @param {string} objectId
 *
 * @return {Identifiable<object> | undefined}
 */
export var findObjectWithId = function (values, objectId) { return findObjectWithIdInObject(values, objectId); };
//# sourceMappingURL=findObjectWithId.js.map